import { cva } from 'class-variance-authority';
import { cn } from '../lib/utils';
import {
  controlFrameClassName,
  controlSizeClasses,
  comfortControlClassName,
} from './control-styles';

// Pure styles remain callable from Server Components.
const buttonStyles = cva(
  `${controlFrameClassName} experience-candidate-button experience-candidate-motion experience-candidate-focus inline-flex shrink-0 max-w-full items-center justify-center gap-2 text-center whitespace-nowrap break-normal transition-interactive duration-200 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 aria-disabled:cursor-not-allowed aria-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0`,
  {
    variants: {
      variant: {
        primary:
          'border border-action bg-action text-action-foreground hover:border-action-hover hover:bg-action-hover active:border-action-hover active:bg-action-hover',
        secondary:
          'border border-border bg-surface-sheet text-text-heading hover:border-control-border hover:bg-surface-soft active:bg-surface-canvas',
        outline:
          'border-border bg-surface-sheet text-text-heading hover:border-control-border hover:bg-surface-soft active:bg-surface-canvas',
        ghost:
          'border-transparent bg-transparent text-text-heading hover:bg-surface-soft active:bg-surface-canvas',
        tertiary:
          'border-transparent bg-transparent text-text-heading hover:bg-surface-soft active:bg-surface-canvas',
        danger:
          'border border-status-danger-fg bg-status-danger-fg text-text-inverse hover:bg-status-critical-fg hover:border-status-critical-fg active:bg-status-critical-fg',
        destructive:
          'border border-status-danger-fg bg-status-danger-fg text-text-inverse hover:bg-status-critical-fg hover:border-status-critical-fg active:bg-status-critical-fg',
        link: 'border-transparent text-action no-underline underline-offset-4 hover:underline focus-visible:underline hover:decoration-2 hover:text-action-hover active:text-action-hover p-0',
      },
      size: {
        ...controlSizeClasses,
        sm: controlSizeClasses.compact,
        lg: controlSizeClasses.default,
        icon: 'h-11 min-h-11 w-11 p-0 text-body',
        comfort: comfortControlClassName,
      },
      density: {
        productive: '',
        comfort: comfortControlClassName,
      },
    },
    compoundVariants: [{ density: 'comfort', size: 'icon', className: 'h-12 w-12' }],
    defaultVariants: {
      variant: 'primary',
      size: 'default',
      density: 'productive',
    },
  },
);

/** Merge deliberate overrides consistently for native buttons and links, including on the server. */
export function buttonVariants(props?: Parameters<typeof buttonStyles>[0]) {
  return cn(buttonStyles(props));
}
